/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {Entity} from '@ion/core/src/types/entities';
import {capitalizeFirstLetter} from '@ion/core/src/utils/StringUtil';
import {errorOptions, successOptions} from '../../../../components/prompts/constants';

/**
 * @successAddOptions
 *
 * Results for the successful add service user prompt that
 * extend the default options
 */
export const successAddOptions = {
  ...successOptions,
  message         : 'common:editors.shared.successCreated',
  translateOption : {
    entity : capitalizeFirstLetter(Entity.maintenanceservice)
  }
};

/**
 * @errorOptions
 *
 * Results for the error add service user prompt that
 * extend the default options
 */
export const errorAddOptions = {
  ...errorOptions,
  message         : 'common:editors.shared.errorCreated',
  translateOption : {
    entity : Entity.maintenanceservice
  }
};

/**
 * @successEditOptions
 *
 * Results for the successful edit service user prompt that
 * extend the default options
 */
export const successEditOptions = {
  ...successAddOptions,
  message : 'common:editors.shared.successEdited'
};

/**
 * @errorOptions
 *
 * Results for the error add service user prompt that
 * extend the default options
 */
export const errorEditOptions = {
  ...errorAddOptions,
  message : 'common:editors.shared.errorEdited'
};
